module.exports = __webpack_public_path__ + "static/media/enem2020.f107364c.png";